module.exports = __webpack_public_path__ + "img/mariscos.7da59da0.jpg";